module.exports = __webpack_public_path__ + "img/M05.a1fbdf5f.png";